import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { isEmpty } from 'lodash'
import IcomoonReact from 'icomoon-react'
import classNames from 'classnames'
import { useToastAlert } from 'src/stores/ToastContext'
import { useGlobalContext } from 'src/stores/GlobalContext'
import { logoutUser } from 'src/utils/helpers/GeneralHelpers'
import { buildLoginUrl } from 'src/utils/helpers/RedirectHelpers'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import LayoutStyles from 'src/components/Layout/layouts.module.scss'
import elementStyles from './elements.module.scss'

const FlashMessage = () => {
  const navigate = useNavigate()
  const { alert: { status, title, message, forceLogout, dismissOnClick }, resetAlert } = useToastAlert()
  const { eventId } = useGlobalContext()
  const messageType = status === 201 ? 'positive' : 'negative'

  useEffect(() => {
    if (dismissOnClick && !isEmpty(message)) {
      const handleDocumentClick = () => {
        resetAlert()
      }
      document.addEventListener('click', handleDocumentClick)
      return () => {
        document.removeEventListener('click', handleDocumentClick)
      }
    }
  }, [dismissOnClick, message, resetAlert])

  const handleLogout = async (e) => {
    e.preventDefault()
    resetAlert()
    logoutUser()
    // Preserve current URL with UTM parameters
    const loginUrl = buildLoginUrl(window.location.pathname + window.location.search)
    navigate(loginUrl)
  }

  if (isEmpty(message)) return <></>

  return (
    <div
      className={classNames(LayoutStyles.flashMessageContainer, {
        [LayoutStyles[`lower${eventId ? 'WithNav' : ''}`]]: !!message
      })}
    >
      <div
        className={classNames(
          elementStyles.flashContainer,
          elementStyles[messageType]
        )}
      >
        <div className={[elementStyles.textContainer]}>
          <span className={messageType === 'positive' ? fontStyles.pdefaultboldlsin01lightbasegraphik18pt : fontStyles.pdefaultboldlsinerrortextgraphik18pt}>{title}: </span>
          <span>
            <span className={messageType === 'positive' ? fontStyles.pdefaultlsin01lightbasegraphik18pt : fontStyles.pdefaultlsinerrortextgraphik18pt}>{message}</span>
            {forceLogout && (
              <span>
                <a href="#" onClick={(e) => handleLogout(e)}>
                  Return to Login
                </a>
              </span>
            )}
          </span>
        </div>
        <div className={elementStyles.closeContainer}>
          <button
            onClick={resetAlert}
            className={elementStyles.iconContainer}
          >
            <IcomoonReact
              iconSet={rebrandIconSet}
              size={12}
              icon="Controls-X"
              id="flashMessageCloseIcon"
            />
          </button>
        </div>
      </div>
    </div>
  )
}

export default FlashMessage
